import { gql } from "lib/apolloClient";

export const downloadFileOfStudentListByFamilyStatusMutation = gql`
  mutation generateStudentFamilyInviteReport(
    $status: [FamilyMemberStatusEnum!]
    $filters: GenerateStudentFamilyInviteReportFilterInput
    $fileName: String
  ) {
    platform {
      generateStudentFamilyInviteReport(
        input: { status: $status, filters: $filters, fileName: $fileName }
      ) {
        url
      }
    }
  }
`;

export const familyInvitationForStudentMutation = gql`
  mutation familyInvitationForStudent(
    $parentsData: [ParentInput!]
    $emailLanguage: LANGUAGE_TYPE_ENUM
    $inviteType: FAMILY_INVITE_TYPE_ENUM!
  ) {
    platform {
      familyInvitationForStudent(
        input: {
          parentsData: $parentsData
          emailLanguage: $emailLanguage
          inviteType: $inviteType
        }
      ) {
        response {
          email
          id
        }
        warning
      }
    }
  }
`;

// returns the status and data after validating the sheet uploaded
export const uploadFamilyMembersDetailTemplateMutation = gql`
  mutation uploadFamilyMembersDetailTemplate($input: EntityBulkUploadInput!) {
    platform {
      entityBulkUpload(input: $input) {
        errorData
        successData {
          added
          updated
          deleted
          reInvited
          mapped
        }
        uploadStatus
      }
    }
  }
`;

// When user confirms the changes made when uploading the sheet
export const confirmFamilyMemberUploadDetailsMutation = gql`
  mutation confirmFamilyMemberUploadDetailsMutation(
    $input: FamilyBulkActionDeciderInput!
  ) {
    platform {
      familyBulkActionDecider(input: $input)
    }
  }
`;

/**
 * @description Educator sends the list of parent emails for class invitation
 */
export const familyInviteForClassMutation = gql`
  mutation familyInviteForClassMutation($input: FamilyClassInvitationInput!) {
    platform {
      familyClassInvitation(input: $input)
    }
  }
`;

/**
 * @description Educator approves/rejects user approval requests
 */
export const decideUserApprovalStatusMutation = gql`
  mutation updateFamilyInvitationStatus(
    $input: UpdateFamilyInvitationStatusInput
  ) {
    platform {
      updateFamilyInvitationStatus(input: $input) {
        id
      }
    }
  }
`;

export const entityBulkUploadCompareDataMutation = gql`
  mutation entityBulkUploadCompareData(
    $input: EntityBulkUploadCompareDataInput!
  ) {
    platform {
      entityBulkUploadCompareData(input: $input) {
        isSuccess
        sheetUrl
        message
      }
    }
  }
`;
